<template>
  <div class='EnbProdutos'>
    <div class="cont-itens">
      <component
      :is="!Prefes.componentModel03Prod ? 'EnbProduto' : Prefes.componentModel03Prod.name"
      v-for="(prod, key) in ProdutosStore.length ? ProdutosStore : DefaultProdutos"
      :key="key"
      :data="prod"
      />
    </div>
    <div class="cont-loader">
      <component
      :is="Prefes.spinner.tipo"
      :color="Prefes.spinner.cor"
      :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '15px' : '40px'"
      style="z-index: 999"
      v-if="load"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbProduto from './Produto/EnbProduto'
import EnbProduto02 from './Produto02/EnbProduto02'
import { loaders } from '@/components/Spinner'
export default {
  name: 'EnbProdutos',
  components: { EnbProduto, EnbProduto02, ...loaders },
  props: ['data'],
  data () {
    return {
      currentThemeProd: 'EnbProduto02',
      load: false,
      DefaultProdutos: [
        {
          id: 9999,
          code: '99999',
          tipo: 'Simples',
          name: 'Imóvel',
          status: true,
          preco: ' 100.000,99',
          oferta: ' 90.000,99',
          img: [],
          descricao: 'Descrição do imóvel',
          dateOfertaStart: '',
          dateOfertaEnd: '',
          categoria: '',
          gerEstoque: false,
          statusEstoque: '',
          estoque: 1,
          exibeSemEstoque: true,
          pendencia: '',
          visibilidade: 1,
          visualizacao: 1,
          atributos: [],
          estoqueVariavel: [],
          caracter: [
            { icon: 'LocationIcon', name: '' },
            { icon: 'RoomsIcon', name: '' },
            { icon: 'ToiletIcon', name: '' },
            { icon: 'ParkingIcon', name: '' },
            { icon: 'AreaIcon', name: '' }
          ],
          destaque: true,
          dateCreate: new Date(),
          link: ''
        }
      ]
    }
  },
  watch: {
    data (n) {
      if (n.scroll.position >= n.scroll.height) {
        this.push()
      }
    }
  },
  computed: {
    ...mapGetters(['Prefes', 'FilterProdStore', 'ProdutosStore'])
  },
  methods: {
    ...mapActions(['GetStoreProducts', 'Loading', 'GetFilterPrice']),
    push () {
      this.load = true
      setTimeout(() => {
        this.GetStoreProducts({ params: {
          last: this.ProdutosStore.map(p => p.id),
          limit: 4,
          categoria: this.FilterProdStore.categoria === '' ? this.$route.params.categ : this.FilterProdStore.categoria
        }, init: false })
        .then(() => {
          this.load = false
        })
      }, 2000)
    }
  },
  created () {
    this.Loading(true)
    this.GetStoreProducts({
      params:
      { 
        last: [],
        limit: 8,
        categoria: typeof this.$route.params.categ !== 'undefined' ? this.$route.params.categ : ''
      }
      ,
      init: true
    })
    .then(() => this.GetFilterPrice())
    .then(res => {
      this.priceRange = res
      this.loadPriceRange = true
      this.Loading(false)
    })
  }
}
</script>

<style scoped>
.EnbProdutos {
  width: 100%;
}

.cont-itens {
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  padding: 1%;
}

.cont-loader {
  height: 60px;
}
</style>
